<main>
  <div class="container">
    <div class="row">
      <aside class="col-lg-3">
        <ul class="sidebar">
          <hyperkit-typography
            display="block"
            class="profile-name"
            variant="h3"
            align="left"
            color="primary"
            >Threat Profile</hyperkit-typography
          >
          <li>
            <hyperkit-link
              (click)="scrollTo('overview')"
              variant="body"
              size="sm"
              color="primary"
              text="Overview"
            >
            </hyperkit-link>
          </li>
          <li>
            <hyperkit-link
              (click)="scrollTo('description')"
              variant="body"
              size="sm"
              color="primary"
              text="Description"
            >
            </hyperkit-link>
          </li>
          <li>
            <ul class="sub">
              @if (profile?.overview && profile?.overview.length > 0) {
                <li>
                  <hyperkit-link
                    (click)="scrollTo('description')"
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Overview"
                  ></hyperkit-link>
                </li>
              }
              @if (profile?.targeting && profile?.targeting.length > 0) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Targeting"
                  ></hyperkit-link>
                </li>
              }
              @if (profile?.delivery && profile?.delivery.length > 0) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Delivery"
                  ></hyperkit-link>
                </li>
              }
              @if (profile?.installation && profile?.installation.length > 0) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Installation"
                  ></hyperkit-link>
                </li>
              }
              @if (profile?.persistence && profile?.persistence.length > 0) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Persistence"
                  ></hyperkit-link>
                </li>
              }
              @if (profile?.modules && profile?.modules.length > 0) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Modules"
                  ></hyperkit-link>
                </li>
              }
              @if (
                profile?.communication && profile?.communication.length > 0
              ) {
                <li>
                  <hyperkit-link
                    variant="body"
                    size="sm"
                    color="primary"
                    text="Communication"
                  ></hyperkit-link>
                </li>
              }
            </ul>
          </li>
          <li>
            <hyperkit-link
              (click)="scrollTo('tagging')"
              variant="body"
              size="sm"
              color="primary"
              text="Tagging"
            >
            </hyperkit-link>
          </li>

          @if (relatedHuntPackages?.length > 0) {
            <li>
              <hyperkit-link
                (click)="scrollTo('relatedHuntPackages')"
                variant="body"
                size="sm"
                color="primary"
                text="Related Hunt Packages"
              >
              </hyperkit-link>
            </li>
          }
          @if (mitres.length > 0 || profile?.mapping.mitre.mitre_software_id) {
            <li>
              <hyperkit-link
                (click)="scrollTo('mitre')"
                variant="body"
                size="sm"
                color="primary"
                text="MITRE Information"
              >
              </hyperkit-link>
            </li>
          }
          <li>
            <hyperkit-link
              (click)="scrollTo('references')"
              variant="body"
              size="sm"
              color="primary"
              text="References"
            >
            </hyperkit-link>
          </li>
        </ul>
      </aside>
      <div class="col-12 col-lg-9 px-0">
        <cyborg-section id="overview">
          <div class="title-row">
            <hyperkit-typography
              class="bookmark"
              class="profile-name"
              variant="h1"
              align="left"
              color="primary"
              >{{ profile?.profile_name }}</hyperkit-typography
            >
            <div class="title-options">
              @if (favorited) {
                <i
                  class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
                  (click)="onRemoveFavorite()"
                ></i>
              }
              @if (!favorited) {
                <i
                  class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
                  (click)="onAddFavorite()"
                >
                </i>
              }
              <hyperkit-button
                size="small"
                color="secondary"
                text="Feedback"
                (click)="onFeedback()"
              ></hyperkit-button>
            </div>
          </div>
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Overview</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Also Known As"
                  ></hyperkit-badge>
                  @if (profile?.also_known_as.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{
                        profile?.also_known_as.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Impact"
                  ></hyperkit-badge>
                  @if (profile?.impact.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{ profile?.impact }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Motivations"
                  ></hyperkit-badge>
                  @if (profile?.context?.motivations.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{
                        profile?.context?.motivations.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Threat Categories"
                  ></hyperkit-badge>
                  @if (profile?.context.threat_categories.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{
                        profile?.context?.threat_categories.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Threat Types"
                  ></hyperkit-badge>
                  @if (profile?.context.threat_types.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{
                        profile?.context.threat_types.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Attack Surfaces"
                  ></hyperkit-badge>
                  @if (profile?.context.attack_surfaces.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{
                        profile?.context.attack_surfaces
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Source Regions"
                  ></hyperkit-badge>
                  @if (profile?.context.source_regions.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{ profile?.context.source_regions }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Source Countries"
                  ></hyperkit-badge>
                  @if (profile?.context.source_countries.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{
                        profile?.context.source_countries
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Target Regions"
                  ></hyperkit-badge>
                  @if (profile?.context.target_regions.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{
                        profile?.context.target_regions.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Target Countries"
                  ></hyperkit-badge>
                  @if (profile?.context.target_countries.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{
                        profile?.context.target_countries.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6 col-lg-4">
                  <hyperkit-badge
                    variant="neutral"
                    text="Target OSes"
                  ></hyperkit-badge>
                  @if (profile?.context.target_oses.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                    >
                      {{
                        profile?.context.target_oses.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-12">
                  <hyperkit-badge
                    variant="neutral"
                    text="Target Industries"
                  ></hyperkit-badge>
                  @if (profile?.context.target_industries.length > 0) {
                    <hyperkit-typography
                      variant="emphasized"
                      size="sm"
                      align="left"
                      color="primary"
                      >{{
                        profile?.context?.target_industries.join(', ')
                      }}</hyperkit-typography
                    >
                  } @else {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section id="description">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Description</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                @if (profile?.overview) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Overview</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.overview"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.targeting) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Targeting</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.targeting"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.delivery) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Delivery</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.delivery"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.installation) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Installation</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.installation"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.persistence) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Persistence</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.persistence"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.modules) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Modules</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.modules"
                    ></hyperkit-markdown>
                  </div>
                }
                @if (profile?.communication) {
                  <div class="col-12">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="primary"
                      >Communication</hyperkit-typography
                    >
                    <hyperkit-markdown
                      [md]="profile?.communication"
                    ></hyperkit-markdown>
                  </div>
                }
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section id="tagging">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Tagging</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                @if (profile?.tags) {
                  <div class="col-12">
                    <cyborg-facet-buttons
                      [closable]="false"
                      class="tile-facets"
                      [facets]="tags"
                      [groupByCategory]="false"
                    ></cyborg-facet-buttons>
                  </div>
                }
              </div>
            </div>
          </div>
        </cyborg-section>
        @if (relatedHuntPackages?.length > 0) {
          <cyborg-section id="relatedHuntPackages">
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary"
                >Related Hunt Packages</hyperkit-typography
              >
            </cyborg-section-title>
            @if (relatedHuntPackages) {
              <div>
                @for (huntPackage of relatedHuntPackages; track huntPackage) {
                  <hunt-package class="col-12" [data]="huntPackage">
                  </hunt-package>
                }
              </div>
            }
          </cyborg-section>
        }

        @if (mitres.length > 0 || profile?.mapping.mitre.mitre_software_id) {
          <cyborg-section id="mitre">
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary"
                >MITRE Information</hyperkit-typography
              >
            </cyborg-section-title>
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row details">
                  <div class="col-12 col-lg-6">
                    <hyperkit-badge
                      variant="neutral"
                      text="MITRE Group ID"
                    ></hyperkit-badge>
                    @if (profile?.mapping.mitre.mitre_software_id) {
                      <hyperkit-link
                        class="link"
                        href="https://attack.mitre.org/software/{{
                          profile?.mapping.mitre.mitre_software_id
                        }}"
                        target="_blank"
                        variant="body"
                        size="sm"
                        display="inline"
                        align="left"
                        color="secondary"
                        text="{{ profile?.mapping.mitre.mitre_software_id }}"
                      ></hyperkit-link>
                    } @else {
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        display="block"
                        align="left"
                        color="primary"
                        >--</hyperkit-typography
                      >
                    }
                  </div>
                  <div class="col-12 col-lg-6">
                    <table class="mitre-table">
                      <thead>
                        <th>
                          <hyperkit-badge
                            display="inline"
                            variant="neutral"
                            text="Mitre Attack Technique"
                          ></hyperkit-badge>
                        </th>
                        <th>
                          <hyperkit-badge
                            display="inline"
                            variant="neutral"
                            text="ID"
                          ></hyperkit-badge>
                        </th>
                      </thead>
                      <tbody>
                        @if (mitres.length === 0) {
                          <tr>
                            <td>
                              <hyperkit-typography
                                variant="body"
                                size="sm"
                                display="block"
                                align="left"
                                color="primary"
                                >--</hyperkit-typography
                              >
                            </td>
                            <td>
                              <hyperkit-typography
                                variant="body"
                                size="sm"
                                display="block"
                                align="left"
                                color="primary"
                                >--</hyperkit-typography
                              >
                            </td>
                          </tr>
                        }
                        @for (mitre of mitres; track mitre) {
                          <tr>
                            <td>
                              <hyperkit-typography
                                variant="body"
                                size="sm"
                                display="inline"
                                align="left"
                                color="secondary"
                                >{{ mitre.technique }}</hyperkit-typography
                              >
                            </td>
                            <td>
                              <hyperkit-link
                                class="link"
                                href="https://attack.mitre.org/techniques/{{
                                  mitre.id.replace('.', '/')
                                }}"
                                target="_blank"
                                variant="body"
                                size="sm"
                                display="inline"
                                align="left"
                                color="secondary"
                                text="{{ mitre.id }}"
                              ></hyperkit-link>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </cyborg-section>
        }

        <cyborg-section id="references">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >References</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="row details">
                <div class="col-6">
                  <hyperkit-badge
                    variant="neutral"
                    text="General"
                  ></hyperkit-badge>
                  @for (link of generalReferences; track link) {
                    <hyperkit-link
                      [href]="link"
                      target="_blank"
                      variant="body"
                      size="sm"
                      color="secondary"
                      [text]="link"
                    >
                    </hyperkit-link>
                  } @empty {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
                <div class="col-6">
                  <hyperkit-badge
                    variant="neutral"
                    text="Intel 471"
                  ></hyperkit-badge>
                  @for (link of intel471References; track link) {
                    <hyperkit-link
                      [href]="link"
                      target="_blank"
                      variant="body"
                      size="sm"
                      color="secondary"
                      [text]="link"
                    >
                    </hyperkit-link>
                  } @empty {
                    <hyperkit-typography
                      variant="body"
                      size="sm"
                      display="block"
                      align="left"
                      color="primary"
                      >--</hyperkit-typography
                    >
                  }
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
      </div>
    </div>
  </div>
</main>
